/**
 * @param {number|string|null|undefined} sid
 * @returns {boolean}
 */
export function looksLikeCallSid(sid) {
  if (!sid) return false;
  const s = String(sid);
  if (s.length < 6) return false;
  return !/[:\s@]/.test(s);
}

export default looksLikeCallSid;
